import { render, staticRenderFns } from "./AppPopover.vue?vue&type=template&id=1f9dedd2&scoped=true"
import script from "./AppPopover.vue?vue&type=script&lang=js"
export * from "./AppPopover.vue?vue&type=script&lang=js"
import style0 from "./AppPopover.vue?vue&type=style&index=0&id=1f9dedd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9dedd2",
  null
  
)

export default component.exports